"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _chromaJs = _interopRequireDefault(require("chroma-js"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _Backdrop = _interopRequireDefault(require("@material-ui/core/Backdrop"));

var _withStyles = _interopRequireDefault(require("@material-ui/styles/withStyles"));

var _styles = require("@material-ui/core/styles");

var useStyles = (0, _styles.makeStyles)({
  paper: {
    backgroundColor: 'transparent'
  }
});
var NewBackdrop = (0, _withStyles["default"])(function (_ref) {
  var palette = _ref.palette;
  return {
    root: {
      backgroundColor: (0, _chromaJs["default"])(palette.app.main).alpha(0.95).hex(),
      backdropFilter: 'blur(3px)'
    }
  };
})(_Backdrop["default"]);

var _default = function _default(props) {
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], (0, _extends2["default"])({}, props, {
    fullScreen: true,
    BackdropComponent: NewBackdrop,
    classes: {
      paper: classes.paper
    }
  }));
};

exports["default"] = _default;
//# sourceMappingURL=index.js.map